
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.009 17L32.392 4.732c.81-.926.81-2.199 0-3.125-.81-.81-2.199-.81-3.009 0L17 13.991 4.732 1.608c-.81-.81-2.199-.81-3.009 0-.926.925-.926 2.199-.115 3.124L13.875 17 1.608 29.268c-.81.926-.81 2.199 0 3.125.81.81 2.199.81 3.009 0L17 20.009l12.268 12.268c.81.81 2.199.81 3.009 0s.81-2.199 0-3.009L20.009 17z"}})])
          )
        }
      }
    